import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { cloneArray } from 'src/app/app.component';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {

  template_list;
  base_functions;
  search;
  filtered_template_list;
  constructor(
    private notification: NotificationService,
    private dialogRef: MatDialogRef<FilterComponent>,
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data,
  ) { }

  ngOnInit(): void {
    if (this.data) {

      this.template_list = this.data['template_list'];
      this.filtered_template_list = cloneArray(this.template_list)
      this.base_functions = this.data['base_functions']
    }

  }

  close(res?) {
    this.dialogRef.close(res)
  }

  newTemplate() {
    (this.data['base_functions'].addNewTemplate)()
  }
  customFilter() {
    (this.data['base_functions'].openFilterModal)()
  }
  editTemplate(item) {
    (this.data['base_functions'].editFilterTemplate)(item)
  }
  selectNewFilter(item) {
    (this.data['base_functions'].filterUsingTemplate)(item)
  }
  searchTemplate(ev) {
    let filter = ev ? ev.toLowerCase() : '';

    if (filter) {
      this.filtered_template_list = [];
      if (this.template_list)
        for (let i = 0; i < this.template_list.length; i++) {
          let option = this.template_list[i];
          if (option && option['filter_template_title']) {
            if (option['filter_template_title'].toLowerCase().indexOf(filter) > -1) {
              this.filtered_template_list.push(option);
            }
          }
        }
    }
    else {
      this.filtered_template_list = this.template_list;
    }
  }
}
